import { IOdataField } from '../../IOdataField';

export abstract class OdataFieldBasicOperator implements IOdataField {
  private field: IOdataField;
  private operator: string;

  constructor(field: IOdataField, operator: string) {
    this.field = field;
    this.operator = operator;
  }

  toFieldString() {
    return `${this.operator}(${this.field.toFieldString()})`;
  };
}
